// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-blue-small-logos-item/banner-hero-blue-small-logos-item.component.scss
// module id = 130
// module chunks = 0